import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=2c03e0e6&scoped=true&"
import script from "./voucher.vue?vue&type=script&lang=ts&"
export * from "./voucher.vue?vue&type=script&lang=ts&"
import style0 from "./voucher.vue?vue&type=style&index=0&id=2c03e0e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c03e0e6",
  null
  
)

export default component.exports